export const FEATURE_FLAGS = {
  FRAUD_INDICATORS: { state: false, queryKey: 'fraud_indicators' },
}
